import { render, staticRenderFns } from "./GalleryLightBox.vue?vue&type=template&id=65f2131b&scoped=true&"
import script from "./GalleryLightBox.vue?vue&type=script&lang=js&"
export * from "./GalleryLightBox.vue?vue&type=script&lang=js&"
import style0 from "./GalleryLightBox.vue?vue&type=style&index=0&id=65f2131b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f2131b",
  null
  
)

export default component.exports